export default __webpack_public_path__ + "static/media/casino-hover.4b36f2df.webp";